import Link from 'next/link';
import {defaultThemeImagePaths, priceHelper} from '@helpers/config-master.mjs';
import {
  CollectionProdPageMobileProdCard
} from '@components/collections/CollectionPageMobileProdCard';
import {JsonLdBreadcrumbList} from '@components/json-ld/breadcrumb-list';
import {GlobalExecute} from '@components/datalayer/global.jsx';
import {viewCollectionPageEvent} from '@components/datalayer/google';
import {CollectionPageHeaderBannerMobile} from '@components/header/Header';

export function CollectionProductsPageMobile({slug, category, title, subtitle, products}) {
  return (
    <>
      <CollectionHeaderAndProductsMobile title={title} subtitle={subtitle} products={products} />
      <JsonLdBreadcrumbList
        handle={'/collections/' + category?.handle}
        title={category?.slug}
        handle2={'/collections/' + slug}
        title2={title}
      />
      <GlobalExecute execute={() => viewCollectionPageEvent(slug, title, products)} />
    </>
  );
}

export function CollectionHeaderAndProductsMobile({title, products, back}) {
  // const mobileProductImageSaleOverlay = useMobileProductImageSaleOverlay();
  const mobileProductImageSaleOverlay = defaultThemeImagePaths?.mobileProductImageSaleOverlay;

  const saleIsEnabled = priceHelper.saleEnabled === true ? true : false;

  return (
    <>
      <CollectionPageHeaderBannerMobile saleIsEnabled={saleIsEnabled} />
      {title && (
        <div>
          <h1
            className='block font-medium text-black text-3xl font-oswald uppercase px-5 mt-1 pt-2 pb-1'
            style={{
              backgroundSize: '100%',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'bottom'
            }}>
            {title}
          </h1>
        </div>
      )}

      <div className='pb-10'>
        <div className='grid grid-cols-1 gap-2'>
          {products?.map((product, index) => {
            const key = product?.sku ?? product?.slug ?? index;
            return (
              <CollectionProdPageMobileProdCard
                key={key}
                product={product}
                mobileProductImageSaleOverlay={mobileProductImageSaleOverlay}
              />
            );
          })}
        </div>

        {back && back?.parent && (
          <div className='flex justify-center mt-10 font-oswald'>
            <Link href={`/collections/${back?.parent?.handle}`}>
              <button className='px-4 py-2 text-black text-lg uppercase font-semibold bg-white rounded-xl'>
                Back to {back?.parent?.category}
              </button>
            </Link>
          </div>
        )}
      </div>
    </>
  );
}
